(function() {

    const siteHeader = document.querySelector('.site-header');
    const toggleMenu = document.querySelector('.menu-icon');
    const siteNav = document.querySelector('.site-nav');
    const menuLinks = document.querySelectorAll('.site-nav__item');
    const dropdownTrigger = document.querySelector('.dropdown__trigger');

    toggleMenu.addEventListener('click', function() {
        siteHeader.classList.toggle('menu-is-open');
        toggleMenu.classList.toggle('menu-is-open');
        siteNav.classList.toggle('menu-is-open');
    });

    menuLinks.forEach(( link ) => {
        link.addEventListener('click', function() {
        });
    });

    dropdownTrigger.addEventListener('click', function(event) {
        event.preventDefault();
        document.querySelector('.dropdown').classList.toggle('is-visible');
        document.querySelector('.dropdown__trigger').classList.toggle('is-branded');
        document.querySelector('.dropdown__plus').classList.toggle('is-hidden');
        document.querySelector('.dropdown__minus').classList.toggle('is-visible');
    });

}());


// WEBPACK FOOTER //
// ./src/js/module/site-nav.js